const Ext = require('ext')
const t = require('translate')
const ResourceNewPanel = require('admin/view/ResourceNewPanel')
const RecordFormPanel = require('admin/component/form/RecordFormPanel')
const DateField = require('admin/component/form/DateField')

const InvoiceNewPanel = Ext.define(null, {
  extend: ResourceNewPanel,

  cls: 'invoice-new-panel',

  module() {
    return require('admin/business/InvoiceResource')
  },

  getFormPanel(cfg) {
    return new RecordFormPanel({
      module: cfg.module,
      operation: 'create',
      items: new DateField({
        fieldLabel: t('Invoice Run Date'),
        name: 'invoiceRunDate',
        format: Date.patterns.SHORT
      })
    })
  }
})

module.exports = InvoiceNewPanel
